<template>
    <!-- 富文本编辑器 -->
    <vue-editor
        class="vue-editor"
        useCustomImageHandler
        @image-added="handleImageAdded1"
        v-model="content"
    ></vue-editor>
</template>
<script>
import { VueEditor } from 'vue2-editor'

export default {
    name: 'editor',
    components: {
        VueEditor
    },
    data() {
        return {
            content: this.value,
             baseUrl: this.$store.state.URL,
        }
        
    },
    props: {
        value: {
            type: String || null || undefined,
            required: true
        }
    },
    methods: {
        handleImageAdded1(file, Editor, cursorLocation) {
             debugger
            let formData = new FormData();
            formData.append('image', file);
            let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open('POST', `${this.$store.state.apiUrl}/api/services/app/Image/TxCloudUploadImage`, true);
            xhr.setRequestHeader("Authorization", 'localStorage.getItem("accessToken")');
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    //向外返回服务器的数据
                    //根据responseXML属性是否为空
                    if (!xhr.responseXML) {
                        let jsonRes = JSON.parse(xhr.responseText);
                        if (jsonRes.success) {
                            debugger
                            let url = this.baseUrl + jsonRes.result.url;
                            Editor.insertEmbed(cursorLocation, 'image', url);
                        } else {
                            this.$message.error(response.errorMsg);
                        }
                    }
                } else if (xhr.readyState === 4 && xhr.status === 500) {
                    this.$message.error('服务器繁忙！');
                }
            }
            xhr.send(formData);
        }
    },
    watch: {
        value(newValue) {
            this.content = newValue
        },
        content(newValue) {
            this.$emit('getContent', newValue)
        }
    }
}
</script>
<style lang="scss">
.vue-editor img {
    display: inline-block;
}
</style>
